<template>
  <div class="draftWrapper">
    <template v-if="isLoading">
      <div class="draftWrapper__loadingWrapper">
        <slot name="loading" />
        <adx-loading/>
      </div>
    </template>
    <div v-else class="busDraft">
      <div class="busDraft__main">
        <template>
          <div v-if="draftCampaigns.length > 0" class="busDraft__main__content">
            <div class="busDraft__main__content__left">
              <div class="busDraft__main__content__left__selection">
                <span :class="['selection-checkbox', selectAll ? 'checked' : '']" @click.stop="toggleCheckAllItem"><i class="icon-check"></i></span>
                <span class="busDraft__main__content__left__selection__text subhead">Select All Transaction</span>
              </div>
              <div v-for="campaign in draftCampaigns" :key="campaign.id" class="busDraft__main__content__left__campaigns">
                <span
                  :class="['selection-checkbox',
                            campaign.is_complete? '' : 'disabled',
                            campaign.is_checked? 'checked' : '']"
                  @click.stop="toggleSelectCampaign(campaign)" :disabled="!campaign.is_complete">
                    <i v-if="campaign.is_complete" class="icon-check"></i>
                </span>
                <div class="sectionWrapper">
                <div class="busDraft__main__content__left__campaigns__section__left">
                  <div class="busDraft__main__content__left__campaigns__section__left__top">
                    <span class="campaign-title subhead">{{campaign.title}}</span>
                  </div>
                  <div class="busDraft__main__content__left__campaigns__section__mid">
                    <span class="subtitle small-font">Campaign detail :</span>
                    <div class="busDraft__main__content__left__campaigns__section__mid__info">
                        <span class="section-key subhead">Period</span>
                        <span class="section-value subhead">{{ campaign.start ? displayPeriod(campaign.start, campaign.end) : 'none'}}</span>
                        <span class="section-key subhead">Ads Duration</span>
                        <span class="section-value subhead">{{ displayDuration(campaign.period) }}</span>
                        <span class="section-key subhead">Total Items</span>
                        <span class="section-value subhead">{{ campaign.item ? campaign.item : '-'}}</span>
                    </div>
                  </div>
                </div>
                <div class="busDraft__main__content__left__campaigns__section__right">
                  <div class="busDraft__main__content__left__campaigns__section__right__price">
                    <span class="small-font price-text">Price</span>
                    <span class="price-detail">{{campaign.totalPrice |formatMoney}}</span>
                  </div>
                  <div class="busDraft__main__content__left__campaigns__section__right__bottom">
                    <div class="buttons">
                      <button type="button" class="secondary btn-small" @click.stop="toCampaignEditor(campaign.id)" :disabled="loading">Edit Campaign</button>
                      <button type="button" class="secondary btn-small" @click.stop="setDeleteCampaign(campaign.id)" :disabled="loading">Delete</button>
                    </div>
                  </div>
                </div>
                </div>
              </div>
            </div>
            <div class="busDraft__main__content__right">
              <div :class="['busDraft__main__content__right__wrapper', summaryPosition]">
                <div class="busDraft__main__content__right__wrapper__summary">
                  <div class="busDraft__main__content__right__wrapper__summary__subtitle subhead">Order Summary</div>
                  <div class="busDraft__main__content__right__wrapper__summary__total_campaign">
                    <span class="selected-campaign subhead">{{ totaltransaction() }}</span>
                    <span class="price subhead">{{campaignsPrice|formatMoney}}</span>
                  </div>
                  <div class="busDraft__main__content__right__wrapper__summary__tax">
                    <span class="tax subhead">PPN 10%</span>
                    <span class="price subhead">{{tax|formatMoney}}</span>
                  </div>
                  <div class="busDraft__main__content__right__wrapper__total">
                    <span class="text subhead">Total Payment</span>
                    <span class="total-price regular-font">{{total|formatMoney}}</span>
                  </div>
                  <div class="busDraft__main__content__right__wrapper__checkout">
                    <button
                      type="button"
                      :class="['primary', 'btn-large', 'btn', isCheckout ? 'disabled' : '']"
                      :disabled="selectedCampaign.length == 0 || isCheckout"
                      @click="checkoutCampaign">
                      Checkout
                      <adx-loading-circle v-if="isCheckout" class="loading-circle"/>
                    </button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>

      </div>
      <!-- Modal -->
      <!-- @modal-close="closeModal" -->
      <adx-modal v-if="isShowModal" title="Order Submitted" type="small"
      >
        <div slot="content" class="busDraft__modal">
          <div class="busDraft__modal__top">
            <span>Our team will contact you soon to validate your order</span>
          </div>
          <div class="busDraft__modal__bottom">
            <button class="btn-regular primary" @click="gotoCampaignDashboard">Campaign Dashboard</button>
          </div>
        </div>
      </adx-modal>
      <adx-modal
        :hide-close="true"
        v-if="modalDelete"
        title="Delete campaign from draft ?"
        type="small"
        @modal-close="closeAndGetData">
          <div slot="content" class="modal-delete">
            <p class="confirmation-text small-font">Do you want to remove this campaign and all its listing item ? <br/> Note : this action can’t be undo. </p>
            <div class="buttons">
              <button
                type="button"
                class="secondary btn-large"
                @click.stop="cancelDeleteCampaign()"
                :disabled="deleting">Cancel</button>
              <button
                type="button"
                :class="['primary', 'btn-large', 'btn-delete', deleting ? 'disabled' : '']"
                @click.stop="deleteButton()"
                :disabled="deleting">
                  Delete
                  <adx-loading-circle v-if="deleting" class="loading-circle" />
                </button>
            </div>
          </div>
      </adx-modal>
    </div>
    <div v-if="!isLoading && draftCampaigns.length < 1" class="busDraft__main__empty">
      <div class="busDraft__main__empty__img">
        <img src="/img/notfound/img-empty-draft@2x.png" alt="">
      </div>
      <span class="busDraft__main__empty__text">Your draft is empty.</span>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import Tooltip from '@/components/Tooltip'
import Modal from '@/components/Modal'
import Loading from '@/components/Loading/Primary'
import LoadingCircle from '@/components/Loading/Secondary-white'
import Checkbox from '@/components/Form/Checkbox'
import api from '@/api'
import { apiV2 } from '@/api/urls'
import lib from '@/lib/util'
import moment from 'moment'
import { mapGetters } from 'vuex'
import { parseErrorGql } from '@/lib/error'

export default {
  name: 'adx-draft',
  components: {
    'adx-tooltip': Tooltip,
    'adx-modal': Modal,
    'adx-loading': Loading,
    'adx-loading-circle': LoadingCircle,
    'adx-checkbox': Checkbox,
  },
  props: {

  },
  data() {
    return {
      // isComplete: [],
      campaignsPrice: 0,
      count:0,
      countCheckout: 0,
      countDelete: 0,
      deleting: false,
      deletedCampaign: null,
      isCheckout: false,
      isLoading: false,
      isShowModal: false,
      loading: false,
      modalDelete: false,
      newLine: '<br />',
      selectAll: false,
      summaryPosition: '', 
      tax: 0,
      total: 0, 
      draftCampaigns : [],
      incompleteCampaign: [2],
      selectedCampaign: [], 
    }
  },
  computed: {
    // isLoading: function(){
    //   return this.$apollo.loading || false
    // },
    ...mapGetters({
      token: 'token'
    })
  },
  apollo: {
    // busDraftCampaigns: {
    //   query: require('@/graphql/bus/query/campaignDraft.gql'),
    //   loadingKey: 'loading',
    //   result(data) {
    //     const { busDraftCampaigns } = data.data
    //     let result = []
    //     busDraftCampaigns.map(campaign => {

    //       let routeCount = this.countRoutes(campaign.orderRoutes)
    //       let complete = campaign.companyName.length && campaign.contactPerson.length && campaign.phoneNumber.length && routeCount > 0
    //       result.push(
    //         {
    //           'id': campaign.id,
    //           'title': campaign.title,
    //           'start': campaign.start,
    //           'end': campaign.end,
    //           'period': campaign.period,
    //           'is_complete' : complete,
    //           'totalPrice' : this.countPrice(campaign),
    //           'item' : routeCount,
    //           'companyName': campaign.companyName,
    //           'contactPerson': campaign.contactPerson,
    //           'is_checked': false,
    //           'phoneNumber': campaign.phoneNumber}
    //       )
    //     })
    //     // console.log('hehe', result)
    //     this.draftCampaigns = result
    //   }
    // },
  },
  watch: {
    selectAll:function(){
      // console.log('select', this.selectAll)
    }
  },
  beforeCreate() {

  },
  created() {
    Vue.$broker.$on("on-scroll", this.setSummaryPosition)
  },
  beforeMount() {

  },
  mounted() {
    localStorage.setItem('apollo-token', this.token)
    // console.log(this.token, this)
    this.isLoading = true
    this.count = 0
    this.getBusDraftCampaigns()
  },
  beforeUpdate() {

  },
  updated() {

  },
  activated() {

  },
  deactivated() {

  },
  beforeDestroy() {

  },
  destroyed() {

  },
  methods: {
    toogleShowModal() {
      this.isShowModal= !this.isShowModal
    },
    closeModal() {
      this.toogleShowModal()
      this.count = 0
      this.getBusDraftCampaigns()
    },
    gotoCampaignDashboard(){
      this.$router.push({name: 'orderexecution'})
    },
    async getBusDraftCampaigns(){
      this.isLoading = true
      try {
        const  res = await  this.$apollo.query({
          query: require('@/graphql/bus/query/campaignDraft.gql'),
          loadingKey:'loading',
          errorPolicy:'all',
          fetchPolicy:'network-only'
        })

        if (res.data){
          if (res.errors){
            this.handleError(res.errors, 'campaign')
          } else {
            const { busDraftCampaigns } = res.data
            let result = []
            await busDraftCampaigns.map(async campaign => {
              let routeCount = await this.countRoutes(campaign.orderRoutes)
              let complete = await campaign.companyName.length && campaign.contactPerson.length && campaign.phoneNumber.length && routeCount > 0
              await result.push(
                {
                  'id': campaign.id,
                  'title': campaign.title,
                  'start': campaign.start,
                  'end': campaign.end,
                  'period': campaign.period,
                  'is_complete' : complete,
                  'totalPrice' : this.countPrice(campaign),
                  'item' : routeCount,
                  'companyName': campaign.companyName,
                  'contactPerson': campaign.contactPerson,
                  'is_checked': false,
                  'phoneNumber': campaign.phoneNumber}
              )
            })
            this.draftCampaigns = await result
            this.isLoading = false
          }
        }  
      }catch(err){
        this.isLoading = false
        this.$router.push({ name: `500` })
      }
    },
    showNotification(){
      this.$notify({
        group: 'saved',
        title: 'Error',
        text: `Something went wrong. Please refresh the page!`,
        type: 'danger'
      });
    },
    async handleError(errors, param){
      const parsedError = parseErrorGql(errors)
      if (parsedError.hasError){
        if (parsedError.code === 403 || parsedError.code === 404 || parsedError.code === 204){
          let code = parsedError.code
          if (parsedError.code === 204) code = 404
          this.$router.push({ name: `${code}` })
        }else if (parsedError.code === 502){
          switch(param){
            case 'campaign':
              this.count++
              if (this.count<3) {
                await this.getBusDraftCampaigns()
              } else{
                this.showNotification()
                // this.isLoading = false
              } 
              break;
            case 'checkout':
              this.countCheckout++
              if (this.countCheckout<3) {
                await this.checkoutCampaign()
              } else {
                this.$notify({
                  group: 'saved',
                  title: 'Error',
                  text: `Failed to checkout.`,
                  type: 'danger'
                });
                this.isCheckout = false
                this.countCheckout = 0
              }
              break;
            case 'deleteCampaign':
              this.countDelete++
              if (this.countDelete<3) {
                await this.deleteCampaign()
              } else {
                this.$notify({
                  group: 'saved',
                  title: 'Error',
                  text: `Campaign failed to delete`,
                  type: 'danger'
                });
                this.countDelete = 0
              }
              break;
          }
        }else {
          this.$router.push({ name: `500` })
        }
      }
    },
    buttonClicked(){
      // console.log('click')
    },
    filterCampaign(campaign){
      let selected = this.selectedCampaign.filter(function(item) {return item.id == campaign})
      if (selected.length > 0) {
        return true
      }
      return false
    },
    toCampaignEditor(id) {
      this.$router.push({path: `/bus/campaigneditor/${id}`})
    },
    setDeleteCampaign(campaign) {
      this.deletedCampaign = campaign
      this.toggleModal()
    },
    async toggleModal() {
      this.modalDelete = !this.modalDelete
    },
    async deleteButton() {
      this.toggleModal()
      this.countDelete = 0
      await this.deleteCampaign()
    },
    closeAndGetData() {
      this.toggleModal()
    },
    cancelDeleteCampaign() {
      this.deletedCampaign = null
      this.toggleModal()
    },
    async deleteCampaign(){
      try {
        const result = await this.$apollo.mutate({
          mutation: require('@/graphql/bus/mutation/campaignDelete.gql'),
          loadingKey: 'loading',
          errorPolicy: 'all',
          variables: {
            id: this.deletedCampaign,
            campaign:{
              deleteCampaign : true
            }
          }
        });
        // await this.$apollo.queries.busDraftCampaigns.refetch()
        if (result.data) {
          if (result.errors){
            this.handleError(result.errors, 'deleteCampaign')
          } else {
            this.count = 0
            await this.getBusDraftCampaigns()
            this.$notify({
              group: 'saved',
              title: 'Success',
              text: `Campaign deleted!`,
              type: 'success'
            });
          }
          
        }
      } catch (err){
        this.$notify({
          group: 'saved',
          title: 'Error',
          text: `Campaign failed to delete`,
          type: 'danger'
        });
        this.countDelete = 0
      }
    },
    toggleCheckAllItem() {
      // console.log('toggle', this.selectAll)
      if (this.selectAll) {

        this.unselectAllItem()
      } else {
        this.selectAllItem()
      }
    },
    selectAllItem() {
      let total = 0
      let tax = 0
      this.selectedCampaign = []
      this.draftCampaigns.forEach((campaign) => {
        if (campaign.is_complete){
          campaign.is_checked = true
          let price = campaign.totalPrice
          tax += (0.1 * price)
          total += campaign.totalPrice
          this.selectedCampaign.push({id :campaign.id, total :campaign.totalPrice})
        }
      })
      let campaignsPrice =  total

      this.campaignsPrice = campaignsPrice
      this.tax = tax
      this.total = total + 0.1 * total
      this.selectAll = true
    },
    unselectAllItem() {
      this.draftCampaigns.forEach((campaign) => {
        campaign.is_checked = false
      })
      this.selectedCampaign = []
      this.campaignsPrice = 0
      this.tax = 0
      this.total = 0
      this.selectAll = false
    },
    toggleSelectCampaign(campaign) {
      if(campaign.is_complete){
        let price = campaign.totalPrice
        let tax = 0.1 * price

        // console.log('price',price,tax, campaign.totalPrice, 0.9 * campaign.totalPrice)
        if (campaign.is_checked){
            campaign.is_checked = !campaign.is_checked
            this.campaignsPrice -= price
            this.tax -= tax
            this.total -= campaign.totalPrice + 0.1 * campaign.totalPrice
            let index = 0
            this.selectedCampaign.forEach((item, idx) => {
              if (item.id == campaign.id) {
                index = idx
              }
            })
            this.selectedCampaign.splice(index, 1)
            this.selectAll = false
        } else{
            campaign.is_checked = !campaign.is_checked
            this.campaignsPrice += price
            this.tax += tax
            this.total += campaign.totalPrice + 0.1 * campaign.totalPrice
            this.selectedCampaign.push({id :campaign.id, total :campaign.totalPrice})
            if(this.totalAllowedCampaign == this.selectedCampaign.length){
              this.selectAll = true
            }
        }

      }
    },
    totaltransaction(){
      let transaction =  this.selectedCampaign.length
      if (transaction <= 1) {
        return transaction + ' Transaction'
      }
      else if (transaction > 1) {
        return transaction + ' Transactions'
      }
    },
    setSummaryPosition() {
      let scrollTop = this.$root.$el.scrollTop
      if (scrollTop >= 140) {
        this.summaryPosition = 'fixed'
      } else {
        this.summaryPosition = ''
      }
    },
    displayPeriod(start, end) {
      let startDate = moment(start, 'YYYY-MM-DD')
      let endDate = moment(end, 'YYYY-MM-DD')
      if (startDate.year() == endDate.year()) {
        return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM', start)} - ${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', end)}`
      } else if (startDate.year() < endDate.year()) {
        return `${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', start)} - ${lib.dateFormat('YYYY-MM-DD', 'DD MMM YYYY', end)}`
      }
    },
    displayDuration(duration) {
       if (duration > 1) {
        return duration + ' months'
      } else {
        return duration + ' month'
      }
    },
    displayTotalItem(item) {
      if (item == 0) {
        return '-'
      } else if (item == 1){
        return `${item.length} item`
      } else {
      return `${item} items`
      }
    },
    countRoutes(item) {
      let count = 0
      if(item) {
        item.forEach(route => {
          count += route.count
        });
      }
      return count
    },
    countPrice(campaign) {
      let price = 0
      if(campaign) {
        // console.log(campaign)
        if (campaign.orderRoutes){
          campaign.orderRoutes.forEach(route => {
            price += (route.bus.generic.price * route.count) * campaign.period
          });
        }
      }
      return price
    },
    async checkoutCampaign(){
      let flag = false
      this.isCheckout = true
      let campaignCheckout = []

      for (let campaign of this.selectedCampaign){
        await campaignCheckout.push({
          id: campaign.id.toString(),
          busCampaignCheckout:{
            checkout: true
          }
        })
      }
      try {
        const result = await this.$apollo.mutate({
          mutation: require('@/graphql/bus/mutation/campaignMultipleCheckout.gql'),
          fetchPolicy: 'no-cache',
          loadingKey: 'loading',
          errorPolicy: 'all',
          variables: {
            checkout:{
              campaigns: campaignCheckout
            }
          }
        });
        
        if (result.data){
          if (result.errors){
            this.handleError(result.errors, 'checkout')
          } else {
            flag = true
            // await this.$apollo.queries.busDraftCampaigns.refetch()
            this.count = 0
            // await this.getBusDraftCampaigns()
            if (flag) {
              this.$notify({
                group: 'saved',
                title: 'Success',
                text: `Campaign successfully created!`,
                type: 'success'
              });
              this.isCheckout = false
              this.toogleShowModal()
              // this.$router.push({name: 'orderexecution'})
            } else {
              this.$notify({
                group: 'saved',
                title: 'Error',
                text: `Failed to checkout.`,
                type: 'danger'
              });
            }
          }
        }
      } catch (err){
        this.$notify({
          group: 'saved',
          title: 'Error',
          text: `Failed to checkout.`,
          type: 'danger'
        });
        this.countCheckout = 0
      }
    },
  }
}
</script>

<style lang='scss' scoped>
@import './index.scss';
</style>

<style lang='scss'>
.incomplete .tooltip {
  &.top .tooltiptext {
    bottom: 120%;
  }
}

.draft {
  .modal {
    .modal__content__header {
      margin-bottom: 0;
      padding: 0 32px;
    }
  }
}

.busDraft{
  &__main{
    &__content {
      &__right {
        &__wrapper {
          &__checkout{
            button{
              width: 100%
            }
          }
        }
      }
    }
  }
  .modal__content__header{
    align-items: center;
    margin-bottom: 8px;
      button {
        display: none;
      }
    } 
  .title.large-font {
    font-size: 28px;
  }
}
</style>
